import React from "react";
import { t } from "i18next";
import { Loader } from "semantic-ui-react";
import useTheme from "../../../../hooks/useTheme";
import AppText from "../../../UI/Texts/AppTexts";

// Shared "load earlier messages" affordance — the main view and the thread
// view both paginate off the same underlying message list (see
// MESSAGE_PAGE_SIZE's comment in MessagesList.jsx) and render the same
// control at its older end.
export const LoadEarlierMessagesButton = ({ isLoading, onLoadMore }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "0.75rem 0",
      }}
    >
      {isLoading ? (
        <Loader active inline size="small" />
      ) : (
        <AppText.FootnoteSmall
          onClick={onLoadMore}
          cursor="pointer"
          textDecoration="underline"
          color={theme.primaryColor}
        >
          {t("chat.load_earlier")}
        </AppText.FootnoteSmall>
      )}
    </div>
  );
};
